// @flow
export default {
  tpos: {
    basketArea: {
      placeOrder: "Place Order",
      items: "Items",
      resetOrder: "Reset Order",
    },
    productArea: {
      specialOrder: "Special Order",
      customiseIndividual: "Customise Individually",
      updateAllItems: "Update all items",
      removeItem: "Remove Item",
      noItemsInCategory: "No items available in this category",
    },
    orderArea: {
      confirmOrderHeader: "Confirm this Order?",
      confirmOrderText:
        "Please make sure the customer is finished ordering before confirming the order.",
      editOrder: "Edit Order",
      confirmOrder: "Confirm order",
      placedOrder: {
        lane: "Lane: {{lane}}",
        noLane: "Order Placed",
        placedOrderText:
          "Please point customer to the correct lane before taking a new order",
        noLanePlacedOrderText:
          "Direct the customer to check-in at the Entrance Kiosk before taking a new order",
        newOrder: "Take a new order",
      },
      processingOrder: "جاري معالجة الطلب ....",
      processingOrderText: "يرجى الانتظار حتى يتم تنفيذ الطلب .",
      aggregatorOrder: {
        orderConfirmed: "Order Confirmed",
        nextOrder:
          "This order has been confirmed. Please take the next aggregator order.",
      },
    },
    settings: "Settings",
    pickupDriveThru: {
      button: "استلام من نافذة السيارة",
      title: "استلام من نافذة السيارة",
      back: "رجوع",
      enterManually: "إدخال يدوي",
      posOrderIdentifier: "رقم الطلب",
      orderPin: "رمز الطلب",
      submit: "إرسال",
      delete: "حذف",
      orderVerified: "تم التحقق من الطلب",
      orderVerifiedMessage: "تم التحقق من الطلب بنجاح.",
      mainMenu: "القائمة الرئيسية",
      errors: {
        unauthorized: "غير مصرح لك بتنفيذ هذا الإجراء.",
        orderNotFound: "الطلب غير موجود في هذا الفرع.",
        alreadyCheckedIn: "تم تسجيل وصول هذا الطلب مسبقًا.",
        validationFailed:
          "فشل التحقق. يرجى التأكد من البيانات والمحاولة مرة أخرى.",
        networkError: "تعذر الاتصال بالخادم. يرجى التحقق من اتصالك.",
        unknown: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      },
    },
    profileArea: {
      confirmLogout: `Please confirm if you'd like to sign out.`,
      yesLogout: "Yes, sign out",
      noLogout: "No, go back",
      mode: "Aggregator mode",
      off: "Off",
      on: "On",
    },
    orderHistoryArea: {
      reprintReceipt: "Reprint Receipt",
      pin: "PIN:",
    },
    aggregators: {
      Careem: "Careem Now",
      Wssel: "Wssel",
      ToYou: "To You",
      Jahez: "Jahez",
    },
    printerArea: {
      errorTitle: "Printer Error",
      errorDescription: "Printing unavailable or configured incorrectly.",
      errorOrder:
        "The order has been placed, but the receipt failed to print. Please reprint the receipt",
    },
  },
  checkoutScreen: {
    addressConfirmed: "تم تأكيد العنوان",
    checkout: "الفاتورة",
    summary: "ملخص الطلب",
    orderOptions: "خيارات الطلب",
    paymentOptions: "خيارات الدفع",
    confirmOrder: "تأكيد الطلب",
    extraSauces: "صلصات إضافية",
    pickup: "الاستلام من",
    pricesInclude: "الأسعار تشمل {{taxPercent}}٪ ضريبة القيمة المضافة",
    productsValue: "قيمة المنتجات",
    basket: "الطلب",
    viewBasket: "عرض الطلب",
    groupOrder: {
      basketStatus: {
        makingChanges: "Making changes",
        confirmed: "Confirmed",
        failedToJoin: "Failed to join",
        browsing: "Browsing…",
        joining: "Joining…",
      },
      groupBasket: "Group Basket",
      viewGroupBasket: "View Group Basket",
      yourItems: "Your items",
      notAddedItems: "You have not added items to your basket",
      group: "Group ({{usersCount}})",
      noUsersJoined: "No one has joined the order yet...",
      groupOrderIntro:
        "Collect orders from friends, family & co-workers. Share the order to get started.",
      share: "Share",
      refresh: "Refresh",
    },
    deleteButton: "حذف",
    checkoutError: "عذراً حدث خطأ ما في عملية إتمام الشراء",
    removeAll: {
      button: "حذف الكل",
      cancel: "إلغاء",
      modalTitle: "حذف جميع المنتجات من السلة",
      modalBody: "هل أنت متأكد من أنك تود حذف جميع المنتجات من السلة؟",
    },
    unavailableItem: "تم إزالة بعض المنتجات في سلتك لكونها غير متوفرة حاليًا",
    okModalButton: "حسنًا",
    unavailable: "غير متوفر",
    edit: "تعديل",
  },
  currency: "{{amount}} ريال",
  editBasketItemScreen: {
    updateOrder: "تعديل الطلب",
  },
  homeScreen: {
    all: "Main Menu",
    ourMenu: "قائمة الطعام",
    deliveryButton: "خدمة التوصيل",
    modal: {
      addressConfirmed: "تم تأكيد العنوان",
      orderOptions: "خيارات الطلب",
      chooseAddress: "اختر عنوان التوصيل",
      chooseRestaurant: "اختر الفرع",
      skipNow: "اختر لاحقًا",
      deliverTo: "عنوان التوصيل:",
      deliverToAddress: "خدمة التوصيل المنزلي",
      pickupFromRestaurant: "خدمة الاستلام (غير متوفرة الآن)",
      pickupAvailable: "خدمة الاستلام",
    },
    menuAvailability: {
      timeRange: "{{startTime}} - {{endTime}}",
      modalText: "هذا المنتج متوفر فقط خلال  {{timeRange}}",
      unavailable: "غير متوفر",
      unavailableText: "هذا المنتج غير متوفر حاليًا",
      okModalButton: "حسنًا",
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت",
      sunday: "الأحد",
    },
  },
  itemScreen: {
    addToOrder: "إضافة إلى الطلب",
    amount: "الكمية",
    free: "مجاني",
    kCalories: "سعرة حرارية",
    nutritionalInfo: "المعلومات الغذائية",
    variations: "بدائل",
    spicy: "حراق",
    remove: "إزالة",
  },
  locationScreen: {
    openingTimes: "أوقات العمل",
    confirm: "تأكيد العنوان المحدد",
    deliveryTo: "التوصيل إلى:",
    restaurant: "الفرع:",
    deliveryChecker: "التحقق من إمكانية التوصيل:",
    orderHere: "اطلب هنا",
    viewAll: "عرض الكل",
    selectRestaurant: "اختيار الفرع",
    waitTimeMinute: "وقت الإنتظار: {{waitingTime}} دقيقة",
    waitTimeMinutes: "وقت الإنتظار: {{waitingTime}} دقيقة",
    delivery: "خدمة التوصيل",
    pickup: "خدمة الاستلام",
    calculating: "جاري التحقق",
    cannotDeliver: "نأسف لعدم تمكننا من التوصيل للعنوان المحدد",
    pickupChecker: "التحقق من خدمة الاستلام من الفروع:",
    cannotPickup: "نأسف لعدم توفر خدمة الاستلام من الفروع في منطقتكم.",
    pickupLocations: "الفروع التي تدعم خدمة الاستلام",
    addressNotSelected: "لم يتم تحديد عنوان الطلب",
    defaultLocation: "نرجو اختيار عنوان التوصيل",
    branchClosed: "لرجاء اختيار فرع آخر حتى نتمكن من خدمتكم",
    restaurantClosedTitle: "هذا الفرع مغلق حاليًا",
    openNow: "مفتوح حاليًا",
    allBranches: "جميع الفروع",
    restaurantClosed: "نعتذر عن كون هذا الفرع مغلق حاليًا، نرجو اختيار فرع آخر",
    distanceKm: "{{distance}} كم",
    locations: "الفروع",
    search: "مدينة ,الفروع",
  },
  loginScreen: {
    emailAddress: "البريد الإلكتروني",
    errors: {
      passwordEightChar: "كلمة المرور يجب أن لا تقل عن ٨ أحرف",
      requiredEmail: "البريد الإلكتروني مطلوب",
      requiredFirstName: "الاسم الأول مطلوب",
      requiredPassword: "كلمة المرور مطلوبة",
      requiredTelephone: "رقم الجوال مطلوب",
      validTelephone: "الرجاء إدخال رقم جوال صحيح، مبتدئًا برقم ٥",
      invalidKSAPhoneNumber:
        "الرجاء إدخال رقم جوال صحيح مكون من ٩ أرقام ويبدأ بالرقم ٥",
      validEmail: "الرجاء إدخال بريد إلكتروني صالح",
    },
    forgotPassword: "هل نسيت كلمة المرور؟",
    needToRegister: "هل تود إنشاء حساب؟",
    password: "كلمة المرور",
    signInButton: "تسجيل دخول",
  },
  orderHistoryScreen: {
    orderHistory: "الطلبات السابقة",
    cancelled: "ملغى",
    deliveryFailed: "غير مكتمل",
    noRecentOrders: "لا يوجد لديك طلبات سابقة",
    statusAndInformation: "الحالة ومعلومات السائق",
  },
  orderScreen: {
    checkClosed: "نهاية الفاتورة",
    needToCancel: "هل تريد إلغاء طلبك؟",
    orderNumber: "طلب #",
    status: "حالة الطلب",
    orderStatus: {
      processing: "تم استلام طلبك",
      preparing: "يتم تحضير طلبك",
      driverCollecting: "أصبح طلبك جاهزًا للتوصيل",
      outForDelivery: "يتم توصيل طلبك",
      delivered: "تم التوصيل",
      failed: "لم نتمكن من توصيل طلبك",
    },
    pickupStatus: {
      collecting: "جاري تحضير الطلب",
      completed: "تم الانتهاء من تحضير الطلب",
      picked_up: "تم تسليم الطلب",
      rejected: "الطلب مرفوض",
      failed: "فشل تسلبم الطلب",
    },
    pending: "جاري التعيين",
    pickupTime: "سيكون جاهزًا {{time}}",
    pickupAt: "وقت الاستلام: {{time}}",
    directions: "الاتجاه إلى الفرع",
    share: "مشاركة معلومات الطلب",
    productsValue: "قيمة المنتجات",
    thankYou:
      "شكرًا لطلبك من البيك\nالأسعار تشمل {{taxPercent}}٪ ضريبة القيمة المضافة",
    total: "المجموع",
    vat: "({{vat}}٪) ضريبة القيمة المضافة",
    yourOrder: "الطلب الخاص بك",
    yourItems: "Your Items",
    orderCancelled: "الطلب ملغى",
    findOrder: "يمكنك إيجاد طلبك في صفحة الطلبات السابقة",
    newOrder: "طلب جديد",
    somethingWrong: "هل تواجه مشكلة؟",
    contactSupport: "تواصل مع فريق خدمة العملاء",
    cancelled: "ملغى",
    cancelOrder: "إلغاء الطلب",
    cancelDialog: {
      title: "إلغاء الطلب",
      message: "هل أنت متأكد من أنك تود الغاء طلبك؟",
      dismiss: "تراجع",
    },
    expired: "لا يمكن الغاء الطلب",
    timeLeft: "{{time}} دقيقة متبقية",
    timeLeftInSeconds: "{{time}} ثانية متبقية",
    viewQr: "عرض الرمز",
    vatAccountNumber: "الرقم الضريبي: {{vat}}",
    shareOrder: {
      albaikPickupOrder: "طلب الاستلام من البيك:",
    },
    shareDirections: {
      title: "مشاركة موقع المطعم",
      message: "لقد تمت مشاركة طلبك بنجاح. هل تود كذلك مشاركة موقع المطعم؟",
      yes: "نعم",
      no: "لا",
    },
  },
  paymentScreen: {
    payWith: "الدفع عن طريق",
    creditDebit: "البطاقة البنكية",
    checkout: "تأكيد الطلب",
    feeTax: "ضريبة القيمة المضافة لخدمة التوصيل ({{tax}}٪)",
    continue: "متابعة",
  },
  payWithCardScreen: {
    cardholderName: "اسم حامل البطاقة",
    cardNumber: "رقم البطاقة",
    expires: "MM/YY تاريخ الإنتهاء",
    cvv: "رمز الأمان (CVV)",
    payWithCardButton: "الدفع عن طريق البطاقة",
    loading: "جاري التحميل...",
    cancel: "إلغاء",
    cardPreview: {
      cardholderName: "NAME",
      expires: "EXPIRES",
    },
    cvvConfirmation: "نرجو تأكيد رمز الأمان (CVV) الخاص ببطاقتك",
    saveCard: "حفظ البطاقة؟",
    errors: {
      cardholderNameRequired: "الرجاء إدخال اسم حامل البطاقة",
      cardholderNameValid: "الرجاء إدخال الإسم باللغة الإنجليزية",
      cardNumberRequired: "الرجاء إدخال رقم البطاقة",
      cardNumberInvalid: "الرجاء التأكد من رقم البطاقة",
      expiresMonthRequired: "الرجاء إدخال شهر انتهاء الصلاحية",
      expiresMonthLength:
        "الرجاء التأكد من أن شهر انتهاء الصلاحية مكون من رقمين فقط",
      expiresMonthInvalid: "الرجاء التأكد من صحة شهر انتهاء الصلاحية",
      expiresYearRequired: "الرجاء إدخال سنة انتهاء الصلاحية",
      expiresYearLength:
        "الرجاء التأكد من أن سنة انتهاء الصلاحية مكونة من رقمين فقط",
      expiresYearInvalid: "الرجاء التأكد من صحة سنة انتهاء الصلاحية",
      cvvRequired: "الرجاء إدخال رمز الأمان المكون من ٣-٤ أرقام",
      cvvInvalid: "الرجاء التأكد من رمز الأمان المكون من ٣-٤ أرقام",
      savedCardsRetrieveError:
        "حدث خطأ أثناء استعادة البطاقات المحفوظة، يرجى المحاولة لاحقًا",
      payment: {
        default:
          "حصل خطأ أثناء الدفع، الرجاء التأكد من المعلومات المدخلة ومعاودة المحاولة مرة أخرى",
        invalidTotal: "الرجاء التأكد من أن السلة غير فارغة",
        cardNumber: "رقم البطاقة الذي تم إدخاله غير صحيح",
        securityCode: "رمز الأمان الذي تم إدخاله غير صحيح",
        expiryMonth: "شهر انتهاء الصلاحية الذي تم إدخاله غير صحيح",
        expiryYear: "سنة  انتهاء الصلاحية التي تم إدخالها غير صحيحة",
        threeDSecureFailed:
          "حصل خطأ في إتمام عملية الدفع مع البنك الخاص بك، الرجاء معاودة المحاولة مرة أخرى",
      },
    },
  },
  saveCardScreen: {
    saveCard: "حفظ البطاقة",
  },
  profileScreen: {
    account: "حساب المستخدم",
    customerCare: "العناية بالعميل",
    midHeader: "البيك الخاص بي",
    orderHistory: "الطلبات السابقة",
    payments: "خيارات الدفع",
    register: "إنشاء حساب",
    sos: "رقمك في جيبك",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل خروج",
    signOutDialog: {
      title: "تسجيل الخروج؟",
      message: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
      cancel: "إلغاء",
    },
  },
  cardsScreen: {
    savedCards: "بطاقات الدفع الخاصة بك",
    addCard: "إضافة بطاقة",
    anotherCard: "بطاقة أخرى",
    ending: "منتهية بـ",
    deleteCard: "مسح البطاقة المنتهية بـ ({{last4}})",
    errorTitle: "خطأ",
    deleteCardAlertTitle: "حذف بطاقة",
    deleteCardAlertText:
      "هل أنت متأكد من أنك تود حذف البطاقة المنتهية بـ  ({{last4}})؟",
    deleteModalOption: "حذف",
    cancelModalOption: "إلغاء",
  },
  accountScreen: {
    english: "English",
    arabic: "العربية",
    contactDetails: "معلومات الاتصال",
    accountSettings: "إعدادات الحساب",
    language: "اللغة",
    submitError: "حصل خطأ في تحديث بياناتك",
    submitSuccess: "تم تحديث بياناتك بنجاح",
    save: "حفظ",
  },
  qrCodeDetailsScreen: {
    pickupOrder: "معلومات طلبك",
    location: "الفرع",
    orderPlaced: "الطلب",
    pickupTime: "موعد استلام الطلب",
    pickupPin: "رمز الطلب #",
    mobileNumber: "رقم الجوال: ",
  },
  registerScreen: {
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    registerButton: "أنشئ حساب",
    telephone: "رقم الجوال",
  },
  smsSecureScreen: {
    smsConfirm: "تأكيد رقم الجوال",
    codeSent:
      "تم إرسال رمز مكون من ٤ أرقام إلى رقم الجوال   ({{mobile}}). نرجو إدخال الرمز هنا.",
    verificationCode: "رمز التأكيد",
    resend: "إعادة إرسال الرمز",
    remaining: "{{attempts}}/٥ محاولة متبقية",
    smsError: "حصل خطأ أثناء تأكيد الرقم",
    codeResent: "تم إعادة إرسال الرمز",
    thanks: "تم تأكيد الطلب بنجاح",
    maxAttempt: "لقد استنفدت جميع المحاولات لتأكيد الرقم",
    resendCountDown:
      "نرجو الإنتظار {{seconds}} ثانية قبل طلب إعادة إرسال الرمز",
  },
  resetScreen: {
    loginToAccount: "تسجيل الدخول إلى حسابك",
    resetButton: "إعادة تعيين كلمة المرور",
    resetSuccess: "الرجاء مراجعة بريدك الإلكتروني لإعادة ضبط كلمة المرور",
  },
  locationAccessScreen: {
    grantAccess: "السماح للوصول لموقعك",
    manualSearch: "اختيار الفرع من القائمة",
    selectRestaurant: "اختيار الفرع",
    accessRequest:
      "نرجو السماح للوصول لموقعك لنتمكن من اقتراح الفرع الأقرب والأسرع إليك. أو اختر الفرع من القائمة",
  },
  connectionErrorScreen: {
    internetUnavailable: "لا يوجد اتصال بالإنترنت",
    connectToInternet:
      "الرجاء التأكد من الاتصال بالإنترنت للتمكن من استخدام التطبيق",
    okButton: "حسنًا",
  },
  userAuthorizationError: {
    message: "لقد تم تسجيل خروجك من التطبيق",
  },
  versionUpgrade: {
    title: "يوجد تحديث جديد للتطبيق",
    message:
      "حتى يمكنك استخدام التطبيق، نرجو التحديث لآخر نسخة من خلال متجر التطبيقات",
    ok: "حسنًا",
    cancel: "إلغاء",
  },
  launchPopup: {
    title: "تنبيه",
    message:
      "زبائننا الكرام،\n\n خلال أوقات الذروة في العيد، وقت التأخير المتوقع لخدمتكم قد يصل إلى ساعتين.\n\n أعضاء فريقنا يسعون جاهدين لخدمتكم بأسرع وقت ممكن.\n\n نقدر تفهمكم ونعتذر لأي ازعاج قد نتسببه لكم، وكل عام وأنتم بخير.",
  },
  rtlGuardScreen: {
    message:
      "تم تحديث إعدادات اللغة، قم بإعادة تشغيل التطبييق لتفعيل التغييرات",
    restart: "إعادة تشغيل",
  },
};
